var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_153_1",
    "data-name": "Component 153 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.667,
    height: 9.812,
    viewBox: "0 0 11.667 9.812",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8949",
    "data-name": "Path 8949",
    d: "M9.465,12.787a.52.52,0,0,1-.225-.043,3.179,3.179,0,0,1-1.66-1.435A3.439,3.439,0,0,1,8.765,6.776l2.024-1.254a3.123,3.123,0,0,1,4.4,1.142A3.437,3.437,0,0,1,14.006,11.2l-.225.164A.65.65,0,1,1,13.02,10.3l.268-.19a2.141,2.141,0,0,0,.77-2.82,1.85,1.85,0,0,0-1.142-.9,1.8,1.8,0,0,0-1.435.226L9.457,7.875a2.133,2.133,0,0,0-.735,2.8,1.874,1.874,0,0,0,.977.848.636.636,0,0,1,.38.83A.65.65,0,0,1,9.465,12.787Z",
    transform: "translate(-7.166 -5.043)",
    fill: "rgba(16,128,255,0.2)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8950",
    "data-name": "Path 8950",
    d: "M13.55,14.855a3.133,3.133,0,0,1-2.734-1.626A3.439,3.439,0,0,1,12,8.7l.225-.164a.65.65,0,0,1,.761,1.055l-.268.19a2.142,2.142,0,0,0-.77,2.82,1.856,1.856,0,0,0,1.142.9,1.8,1.8,0,0,0,1.436-.225l2.024-1.254a2.135,2.135,0,0,0,.735-2.8,1.876,1.876,0,0,0-.978-.847.646.646,0,1,1,.45-1.211,3.173,3.173,0,0,1,1.66,1.436,3.436,3.436,0,0,1-1.184,4.532L15.21,14.379a3.184,3.184,0,0,1-1.66.476Z",
    transform: "translate(-7.166 -5.043)",
    fill: "rgba(16,128,255,0.7)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanddIcon);
export default __webpack_public_path__ + "static/media/panddIcon.915675c3243c6374477adb7f2a60781c.svg";
export { ForwardRef as ReactComponent };